import React, { useEffect, useState } from "react";
import AppLayout from "../../core/layouts/AppLayout";
import "../../styles/listing.scss";

import Moment from "react-moment";
import moment from "moment";
import classnames from "classnames";
import {
  ListTable,
  ListTableColumn,
  ListHeader,
  Dict,
  FilterValueType,
  getFilters,
  PaginatedApiResponse,
  ListSort,
  SortOrder,
  Showroom,
  QueryFilter,
  ListFilters,
  ListHeaderSearch,
  MultiSelectFilter,
  ListColumnSettings,
  SavedFilter,
  ListEntityType,
  Column,
  capitalizeFirstLetter,
  useLead,
  useConfiguration,
} from "../../core";
import { State } from "../../core/store/interfaces";
import { useMasterData } from "../../core/hooks/useMasterData";
import api from "../../api";
import { useDataLoader, usePerformAction } from "react-remote-data-hooks";
import { ContainerLoader, Spinner } from "../../components/loader";
import { useAppSettings } from "../../core/hooks/useAppSettings";
import { useHistory, useLocation } from "react-router-dom";
import queryString, { ParsedQuery } from "query-string";

import DateRangeListFilter, {
  IDateRange,
} from "../../core/components/list-filters/DateRangeListFilter";
import Pagination from "../../core/components/pagination/Pagination";
import { RouteKeys } from "../routes/route-keys";
import { toastr } from "react-redux-toastr";
import { LeadRequirement } from "../../core/api/models/requirement";
import { IListTableColumnProps } from "../../core/components/list-table/ListTableColumn";
import Tabs from "./Tabs";
import { TabNames } from "./props";
import Requirement from "../requirement/Requirement";
import { useSelector } from "react-redux";
import { decodeHtmlEntities } from "../../utils/common";

const columnList = [
  <ListTableColumn
    label="Lead Type"
    source="leadDetails.leadType.name"
    column="leadType"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Lead Intent"
    source="leadDetails.leadIntent.name"
    column="leadIntent"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Property Type Interested"
    source="propertyTypeDetails.propertyTypeName"
    column="productTypeInterested"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Lead Title"
    source="leadDetails.title"
    column="leadTitle"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Contact Name"
    source="leadDetails.customer.fullName"
    column="fullName"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,

  <ListTableColumn
    label="Company Name"
    source="leadDetails.company.name"
    column="name"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Transaction Manager"
    source="leadDetails.currentCRMAgent.name"
    column="transactionExecutive"
    showDefault
    // sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Support Executive"
    source="leadDetails.currentSalesPerson.name"
    column="BusinessDeveloperExecutive"
    showDefault
    // sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Requested Date"
    source="createdAt"
    column="createdAt"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Created By"
    source="createdBy.name"
    column="createdBy.name"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,

  <ListTableColumn
    label="Phone"
    source="leadDetails.customer.phone"
    column="phone"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Email"
    source="leadDetails.customer.email"
    column="email"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,

  <ListTableColumn
    label="Version"
    source="versionNumber"
    column="propertyPurpose"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Version Status"
    source="status"
    column="versionStatus"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
];

const approvedColumns = [
  <ListTableColumn
    label="Approved By"
    source="approvedBy.name"
    column="approvedBy.name"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Approved Date"
    source="approvedAt"
    column="approvedAt"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
];

const rejectedColumns = [
  <ListTableColumn
    label="Rejected By"
    source="rejectedBy.name"
    column="rejectedBy.name"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
  <ListTableColumn
    label="Rejected Date"
    source="rejectedAt"
    column="rejectedAt"
    showDefault
    sortable
    settingsGroup="Requirement"
  ></ListTableColumn>,
];

const RequirementsList: React.FunctionComponent = () => {
  const history = useHistory();
  const params = useLocation().search;
  const masterData = useMasterData(api.settings);
  const [search, setSearch] = useState("");

  const [filters, setFilters] = useState<Dict<FilterValueType>>({});

  const [tabName, setTabName] = useState<TabNames>(TabNames.Requests);
  const [propertyType, setPropertyType] = useState<any>([]);
  const [transactionExecutive, setTransactionExecutive] = useState<any>([]);
  const [userList, setUserList] = useState<any>([]);

  const { data: leadSettings, reload: reloadSettings } = useDataLoader<{
    filters: SavedFilter[];
    columnSettings?: ListColumnSettings;
  }>(() => api.settings.getListColumnSettings(ListEntityType.Requirement));
  const { getLead } = useLead(api.lead);
  const leadState = useSelector((state: State) => state.lead);
  const { openModal, modalOpen: requirementModalOpen } = useConfiguration(api);
  const [savedColumns, setSavedColumns] = React.useState<Column[]>([]);

  const [columns, setColumns] = useState<JSX.Element[]>(columnList);

  useEffect(() => {
    const newColumns = [...columnList]; // Create a copy of the initial columns

    if (tabName === TabNames.Approved) {
      newColumns.push(...approvedColumns); // Add approvedColumns
    } else if (tabName === TabNames.Rejected) {
      newColumns.push(...rejectedColumns); // Add rejectedColumns
    }
    setColumns(newColumns); // Update the columns state with the new array
  }, [tabName]);

  useEffect(() => {
    const handleFilterOptionsApi = async () => {
      try {
        const propertyTypeData = await api.AddNewRequirement.getPropertyType();
        const subTypes = propertyTypeData.reduce((acc: any, item: any) => {
          acc.push(
            ...item.subTypes.map(
              (subType: { _id: any; propertyTypeName: any }) => ({
                value: subType._id,
                name: decodeHtmlEntities(subType.propertyTypeName),
              })
            )
          );
          return acc;
        }, []);
        setPropertyType(subTypes);
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }

      try {
        const transactionExecutiveData = await api.user.getCrmAgents({
          sortBy: "name",
          sortOrder: SortOrder.ASC,
        })

        const transactionExecutiveOptions = transactionExecutiveData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.name),
        }));
        setTransactionExecutive(transactionExecutiveOptions)
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
      try {
        const userListData = await api.user.getUserList();
        const userListDataOptions = userListData?.map((item: any) => ({
          value: item._id,
          name: decodeHtmlEntities(item?.name),
        }));
        setUserList(userListDataOptions)
      } catch (error) {
        // console.log("Failed to fetch property type data:", error);
      }
    };

    handleFilterOptionsApi()
  }, [])

  const {
    performAction: saveFilter,
    isPerforming: savingFilter,
  } = usePerformAction(
    (fls: Dict<FilterValueType>, name: string) =>
      api.settings.saveFilter(fls, name, ListEntityType.Requirement),
    () => {
      toastr.success("Success", "Filter Saved");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to save filter");
    }
  );

  const { performAction: removeFilter } = usePerformAction(
    (_id: string) => api.settings.removeSavedFilter(_id),
    () => {
      toastr.success("Success", "Filter Removed");
      reloadSettings();
    },
    () => {
      toastr.error("Error", "Unable to remove filter");
    }
  );

  const { performAction: saveColumnSettings } = usePerformAction(
    (cols: Column[]) =>
      api.settings.saveListColumnSettings(cols, ListEntityType.Requirement),
    reloadSettings
  );

  const loadFromQuery = () => {
    const queryFilter: QueryFilter = {};
    const queries: ParsedQuery<string> = queryString.parse(params);
    queryFilter.query = queries.query as string;
    if (queries.filters) {
      queryFilter.filters = JSON.parse(queries.filters?.toString());
    }
    if (queries.page) {
      queryFilter.page = Number(queries.page || 1);
    }
    if (queries.perPage) {
      queryFilter.perPage = Number(queries.perPage || 1);
    }
    if (queries.startDate) {
      queryFilter.startDate = moment(queries.startDate as string).toDate();
    }
    if (queries.endDate) {
      queryFilter.endDate = moment(queries.endDate as string).toDate();
    }

    if (queries.sort) {
      queryFilter.sort = JSON.parse(queries.sort?.toString());
    }

    if (queries.listView) {
      queryFilter.listView = queries.listView?.toString();
    }

    return queryFilter;
  };

  const [listView, setListView] = useState(
    loadFromQuery().listView || "requirement"
  );

  const [dateFilters, setDateFilters] = useState<IDateRange | undefined>({
    startDate: loadFromQuery()?.startDate,
    endDate: loadFromQuery()?.endDate,
  });

  // const [state, setState] = React.useState([
  //   {
  //     startDate: new Date(),
  //     endDate: null,
  //     key: "selection",
  //   },
  // ]);

  const {
    performAction: downloadRmaReport,
    isPerforming: downloading,
  } = usePerformAction(async () => {
    let excelColumns: {
      label: string;
      source?: string;
    }[] = columns
      ?.map((column) => {
        if (columns) {
          const selectedColumn = columns?.find(
            (col) => col?.props?.column === column?.key
          ) as { props: IListTableColumnProps };
          if (selectedColumn && !selectedColumn.props.ignoreOnExcel) {
            return {
              label: selectedColumn?.props?.label || "",
              source:
                selectedColumn?.props?.excelSource ||
                selectedColumn?.props?.source?.toString(),
            };
          }
        }
      })
      .filter((a) => !!a) as {
        label: string;
        source?: string;
      }[];
    if (!excelColumns?.length) {
      const allColumns = columns as { props: IListTableColumnProps }[];
      excelColumns = allColumns
        .filter((col) => col.props.showDefault && !col.props.ignoreOnExcel)
        .map((selectedColumn) => {
          return {
            label: selectedColumn?.props?.label || "",
            source:
              selectedColumn?.props?.excelSource ||
              selectedColumn?.props?.source?.toString(),
          };
        });
    }
    await api.settings.downloadRequirements({
      fromDate: dateFilters?.startDate
        ? moment(dateFilters?.startDate).startOf("day").toDate()
        : undefined,
      toDate: dateFilters?.endDate
        ? moment(dateFilters?.endDate).endOf("day").toDate()
        : undefined,
      ...getFilters(filters),
      query: search,
      columns: excelColumns.filter((a) => !!a.source),
      isRejected: false,
      status: tabName.toLowerCase(),
    });
  });

  const [sort, setSort] = useState<ListSort>({
    sortBy: loadFromQuery()?.sort?.sortBy || "createdAt",
    sortOrder: loadFromQuery()?.sort?.sortOrder || SortOrder.DESC,
  });

  const [page, setPage] = React.useState(loadFromQuery()?.page || 1);
  const [perPage, setPerPage] = React.useState(loadFromQuery()?.perPage || 20);
  const [requirementId, setRequirementId] = React.useState<string | null>(null);

  const { data, loading, loaded, reload } = useDataLoader<
    PaginatedApiResponse<LeadRequirement> & { lastUpdatedAt: Date }
  >(
    (
      searchTerm: string | undefined,
      searchFilters: Dict<FilterValueType>,
      currentPage: number,
      pageCount: number,
      searchOrder?: ListSort,
      dates?: IDateRange
    ) => {
      const currentFilter = {
        ...getFilters(loadFromQuery()?.filters || searchFilters),
      };

      if (currentFilter.salesStatus?.includes("ConfirmedSale")) {
        currentFilter.salesStatus = [
          ...currentFilter.salesStatus?.filter(
            (x: any) => x !== "ConfirmedSale"
          ),
          "Ordered",
          "OrderConfirmed",
        ];
      }

      return api.requirement.getRequirements({
        ...currentFilter,
        fromDate: dates?.startDate
          ? moment(dates?.startDate).startOf("day").toDate()
          : undefined,
        toDate: dates?.endDate
          ? moment(dates?.endDate).endOf("day").toDate()
          : undefined,
        page: currentPage,
        query: loadFromQuery()?.query || searchTerm,
        sortBy: searchOrder?.sortBy,
        sortOrder: searchOrder?.sortOrder,
        perPage: pageCount,
        status: tabName === TabNames.Requests ? undefined : tabName.toLowerCase()
      });
    },
    [search, filters, page, perPage, tabName, sort, dateFilters]
  );

  useEffect(() => {
    if (loaded) {
      setPage(1);
      onChangeFilter(filters, search, 1, perPage, dateFilters, sort);
      reload(search, filters, 1, perPage, tabName, sort, dateFilters);
      // reload(search, filters, dateFilters, sort);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, filters, sort, perPage, dateFilters, tabName]);

  useEffect(() => {
    if (loaded) {
      reload(search, filters, page, perPage, sort, dateFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  React.useEffect(() => {
    const filterResonse = loadFromQuery();

    if (filterResonse.query) {
      setSearch(filterResonse.query as string);
    }

    if (filterResonse.filters) {
      if (
        filterResonse.filters?.autolineStatus &&
        Array.isArray(filterResonse.filters.autolineStatus)
      ) {
        filterResonse.filters.autolineStatus = filterResonse.filters.autolineStatus?.filter(
          (x: any) => x.value !== "PreVin" && x.value !== "Produced"
        );
        if (!filterResonse.filters.autolineStatus?.length) {
          delete filterResonse.filters.autolineStatus;
        }
      }
      setFilters(filterResonse.filters);
    }

    if (filterResonse.page) {
      setPage(filterResonse.page);
    }
    if (filterResonse.perPage) {
      setPerPage(filterResonse.perPage);
    }
  }, []);

  const [selected, setSelected] = useState<string[]>([]);

  const onSaveFilter = (name: string) => {
    saveFilter(filters, name);
  };

  const onRemoveFilter = (_id: string) => {
    removeFilter(_id);
  };

  const onChangeFilter = (
    searchFilters: Dict<FilterValueType>,
    searchValue: string,
    currentPage: number,
    numberOfPages: number,
    dates?: IDateRange,
    sortOption?: ListSort
  ) => {
    let query = `query=${encodeURIComponent(
      searchValue
    )}&page=${currentPage}&perPage=${numberOfPages}`;

    if (
      getFilters(searchFilters) &&
      Object.keys(getFilters(searchFilters)).length
    ) {
      query =
        query + `&filters=` + encodeURIComponent(JSON.stringify(searchFilters));
    }
    if (dates?.startDate) {
      query =
        query + `&startDate=` + moment(dates?.startDate).format("DD-MMM-YYYY");
    }
    if (dates?.endDate) {
      query =
        query + `&endDate=` + moment(dates?.endDate).format("DD-MMM-YYYY");
    }
    if (sortOption && sortOption.sortBy) {
      query = query + `&sort=` + JSON.stringify(sortOption);
    }
    history.replace(`/requirements?${query}`);
  };

  const filterRow = (
    <ListFilters
      key="filter-row"
      savedFilters={leadSettings?.filters || []}
      onSaveFilter={onSaveFilter}
      isSavingFilter={savingFilter}
      onRemoveFilter={onRemoveFilter}
      filters={filters}
      onFilter={(searchFilters: Dict<FilterValueType>) => {
        onChangeFilter(searchFilters, search, page, perPage, dateFilters, sort);
        setFilters(searchFilters);
      }}
    >
      <MultiSelectFilter
        label="Lead Intent"
        filterKey="leadIntent"
        key="leadIntent"
        allowSearch
        options={masterData.data?.leadIntents || []}
        valueField="_id"
        labelField="name"
      />
      <MultiSelectFilter
        label="Lead Type"
        filterKey="leadType"
        key="leadType"
        allowSearch
        options={masterData.data?.leadTypes || []}
        valueField="_id"
        labelField="name"
      />
      <MultiSelectFilter
        label="Property type"
        filterKey="propertytypes"
        key="propertytypes"
        allowSearch
        options={propertyType || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Transaction Manager"
        filterKey="agents"
        key="agents"
        allowSearch
        options={transactionExecutive || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Created By"
        filterKey="createdBy"
        key="createdBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Approved By"
        filterKey="approvedBy"
        key="approvedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />
      <MultiSelectFilter
        label="Rejected By"
        filterKey="rejectedBy"
        key="rejectedBy"
        allowSearch
        options={userList || []}
        valueField="value"
        labelField="name"
      />

    </ListFilters>
  );

  const headerActions = [
    <ListHeaderSearch
      placeholder="Customer Name , Property Type"
      serachTerm={search}
      onSearch={(val: string) => {
        onChangeFilter(filters, val, page, perPage, dateFilters, sort);
        setSearch(val);
      }}
    />,
    <DateRangeListFilter
      default={dateFilters}
      onChange={(d?: IDateRange) => {
        setDateFilters({
          startDate: d?.startDate,
          endDate: d?.endDate,
        });
        if (loaded) {
          onChangeFilter(
            filters,
            search,
            page,
            perPage,
            {
              startDate: d?.startDate,
              endDate: d?.endDate,
            },
            sort
          );
        }
      }}
    />,
  ];

  headerActions.push(
    downloading ? (
      <span className="cursor-pointer p-0 m-0">
        <Spinner height={40} width={40} />
      </span>
    ) : (
      <span className="cursor-pointer" onClick={downloadRmaReport}>
        <i className="icon-download font-xxl"></i>
      </span>
    )
  );

  const getDataByTabNames = (tabData: any, clickedTabName: string) => {
    if (tabName === TabNames.Requests) {
      return tabData?.map((item: any) => {
        if (item?.status) {
          return {
            ...item,
            status: capitalizeFirstLetter(item.status),
            createdAt: moment(item?.createdAt).format("DD/MM/YY h:mm A"),
          };
        }
        return item;
      });
    } else {
      const filteredByStatus = tabData
        .filter((item: any) => capitalizeFirstLetter(item.status) === tabName)
        .map((item: any) => {
          if (item?.status) {
            return {
              ...item,
              status: capitalizeFirstLetter(item.status),
              createdAt: moment(item?.createdAt).format("DD/MM/YY h:mm A"),
              ...(item.approvedAt && {
                approvedAt: item?.approvedAt
                  ? moment(item?.approvedAt).format("DD/MM/YY h:mm A")
                  : "",
              }),
              ...(item.rejectedAt && {
                rejectedAt: item?.rejectedAt
                  ? moment(item?.rejectedAt).format("DD/MM/YY h:mm A")
                  : "",
              }),
            };
          }
          return item;
        });
      return filteredByStatus;
    }
  };

  const onRequirementClick = (id: string) => {
    history.push(`${RouteKeys.Requirement.replace(":id", id)}`);
  }; 

  return (
    <AppLayout>
      <>
        <ListHeader additionalRows={[filterRow]} actions={headerActions}>
          <div className="d-flex align-items-center">
            <h2 className="m-0 d-flex align-items-baseline flex-column">
              Requirements
              {data && (
                <span className="font-xs text-muted font-weight-semibold d-block ml-2 pt-2">
                  {data.count} Total
                  <span className="font-weight-normal ml-1">
                    Updated <Moment fromNow date={data.lastUpdatedAt} />
                  </span>
                  {selected.length > 0 && (
                    <span className="font-weight-normal ml-1">
                      Selected {selected.length} items
                    </span>
                  )}
                </span>
              )}
            </h2>
            <div className="view-switch ml-lg-5 ml-md-4 ml-auto pl-3 d-flex">
              <div className="border rounded-sm d-flex font-normal"></div>
            </div>
          </div>
        </ListHeader>
        <Tabs
          tabChangeHandler={(tb: TabNames) => {
            setTabName(tb);
          }}
          tabName={tabName}
        />
        <>
          {(!loaded || loading) && (
            <ContainerLoader
              height={window.innerHeight - 300}
            ></ContainerLoader>
          )}
          {loaded && !loading && (
            <ListTable
              data={getDataByTabNames(data?.data, tabName)}
              showColumnSettings
              selectedValues={selected}
              // currentCoulumns={
              //   columns?.length
              //     ? columns?.map((item) => item?.props?.column)
              //     : []
              // }
              onSelect={setSelected}
              onSort={(sortKey: string, sortOrder?: SortOrder) => {
                setSort({ sortBy: sortKey, sortOrder });
                onChangeFilter(filters, search, page, perPage, dateFilters, {
                  sortBy: sortKey,
                  sortOrder,
                });
              }}
              sort={sort}
              trProps={(d: LeadRequirement) => {
                return {
                  className: classnames({
                    "cursor-pointer": true,
                  }),
                  onClick: () => {
                    onRequirementClick(d._id);
                  },
                };
              }}
              selectedColumns={savedColumns?.length ? savedColumns : undefined}
              onColumnSettingsSaved={(sColumns: Column[]) => setSavedColumns(sColumns)}
            >
              {columns}
            </ListTable>
          )}
          <Pagination
            currentPage={page}
            totalPages={data?.totalPages}
            onPageChange={(pg: number) => {
              setPage(pg);
              onChangeFilter(filters, search, pg, perPage, dateFilters, sort);
            }}
            perPage={perPage}
            onPerPageChange={(pg: number) => {
              setPerPage(pg);
              onChangeFilter(filters, search, page, pg, dateFilters, sort);
            }}
            count={data?.count}
            label="requirements"
          />
          {requirementModalOpen && leadState?.leadDetails && requirementId && (
            <Requirement
              leads={[leadState?.leadDetails]}
              customer={leadState?.leadDetails?.customer}
              reload={() => {
                getLead(leadState?.leadDetails?._id!);
              }}
            ></Requirement>
          )}
        </>
      </>
    </AppLayout>
  );
};

export default RequirementsList;
